import React from 'react';
import { useTranslation } from 'react-i18next';
import './GreenSection.scss';

const GreenSection = () => {
  const { t } = useTranslation();
  return (
    <section className="green-section">
      <div className="green-section__container">
        <div className="green-section__glass">
          <p className="green-section__text">
            {t('greenSection.description')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default GreenSection;
